{
	"title": "Слабые места",
	"subtitle": "Карта пробелов: что повторить в первую очередь",
	"intro": {
		"title": "Что такое слабые места",
		"body": "Сюда попадает то, в чём вы ошиблись в тестах и карточках. Список ведётся сам и обновляется после каждой проверки.",
		"bullets": [
			"Появляются после тестов — вручную заводить нечего",
			"Уверенная ошибка поднимается вверх списка",
			"По любому пункту можно собрать карточки, тест или сессию с репетитором"
		]
	},
	"errorTitle": "Не удалось загрузить",
	"errorDescription": "Проверь соединение и попробуй ещё раз.",
	"retry": "Повторить",
	"filterStatus": "Статус",
	"filterSeverity": "Серьёзность",
	"filterMaterial": "Материал",
	"clearSeverity": "Сбросить «{level}»",
	"all": "Все",
	"active": "Активные",
	"resolving": "В работе",
	"resolved": "Закрытые",
	"severity": {
		"low": "Низкая",
		"medium": "Средняя",
		"high": "Высокая"
	},
	"severityMeter": {
		"label": "Серьёзность: {level}"
	},
	"summary": {
		"label": "Сводка по пробелам",
		"openGaps": "{count, plural, one {открытый пробел} few {открытых пробела} other {открытых пробелов}}",
		"resolved": "{count, plural, one {# закрыт} few {# закрыто} other {# закрыто}}"
	},
	"search": "Поиск по теме пробела",
	"view": {
		"byMaterial": "По материалам",
		"list": "Список"
	},
	"group": {
		"unassigned": "Без привязки к материалу"
	},
	"emptySearchTitle": "Ничего не найдено",
	"emptySearchDescription": "Под запрос ничего не подошло. Измени запрос или сбрось фильтры.",
	"emptySearchAction": "Сбросить поиск",
	"card": {
		"questions": "{wrong} из {total} с ошибкой",
		"confidentWrong": "Уверен и не прав: {count}",
		"luckyGuesses": "Случайно угадал: {count}",
		"detected": "Обнаружено {date}",
		"lastSeen": "Замечено {date}",
		"mismatch": "Уверенность не совпала с результатом",
		"closureLabel": "Прогресс закрытия",
		"actions": "Действия",
		"recentActions": "Недавние действия по устранению пробелов"
	},
	"actions": {
		"closeGap": "Закрыть пробел",
		"repeatCards": "Карточки на повтор",
		"repeatCardsQueued": "Карточки готовятся — придёт уведомление",
		"miniQuiz": "Мини-тест",
		"miniQuizQueued": "Мини-тест генерируется — откроется по готовности",
		"aiExplain": "Спросить AI",
		"aiExplainQueued": "Открываю чат с AI по этой теме",
		"studyPlanAdd": "В учебный план",
		"studyPlanAddDescription": "Выбери план, в который добавить раздел повторения по этой теме.",
		"studyPlanAddPlaceholder": "Выбери учебный план",
		"studyPlanAddEmpty": "У тебя пока нет учебных планов. Создай план — и потом добавишь в него эту тему.",
		"studyPlanCreate": "Создать план",
		"studyPlanAddError": "Не удалось добавить в план",
		"studyPlanLoading": "Загружаем планы…",
		"error": "Не удалось выполнить действие",
		"cancel": "Отмена",
		"dismiss": "Скрыть",
		"markResolved": "Отметить закрытым",
		"openTopicGap": "Закрыть в курсе"
	},
	"back": "К результатам теста",
	"emptySuccessTitle": "Слабых мест нет",
	"emptySuccessDescription": "Ты держишь материал под контролем. Пройди тест — и AI отметит темы, которые стоит повторить.",
	"emptySuccessAction": "К тестам",
	"emptyResolvedTitle": "Закрытых пробелов пока нет",
	"emptyResolvedDescription": "Здесь появятся темы, которые ты проработал и закрыл.",
	"emptyFilterTitle": "Нет пробелов с такой серьёзностью",
	"emptyFilterDescription": "Под выбранный фильтр ничего не подошло. Сбрось фильтр, чтобы увидеть все пробелы.",
	"emptyFilterAction": "Сбросить фильтр",
	"dismiss": {
		"title": "Скрыть слабое место?",
		"description": "Тема больше не будет появляться в рекомендациях. Можно вернуть из архива.",
		"confirm": "Скрыть",
		"cancel": "Отмена"
	},
	"tools": {
		"dialogTitle": "Устранить пробел",
		"dialogDescription": "Выберите способ проработки темы «{topic}». Инструменты чата открывают новую сессию с тьютором.",
		"sections": {
			"recommended": "Рекомендуемое"
		},
		"items": {
			"openCourse": {
				"hint": "Продолжить изучение темы в курсе"
			},
			"miniQuiz": {
				"hint": "Короткий тематический тест для устранения этого пробела"
			},
			"studyPlan": {
				"hint": "Сохранить задачу по этой теме в плане"
			},
			"studyNote": {
				"title": "Учебная заметка",
				"hint": "AI-конспект, сфокусированный на этой слабой теме"
			}
		},
		"prompts": {
			"explain": "Объясни «{topic}». Я допустил ошибку в тесте — помоги устранить пробел в знаниях с помощью четкого объяснения и короткой проверки."
		},
		"studyNoteQueued": "Заметка создается — открываю редактор",
		"studyNoteNeedsMaterial": "Этот пробел не привязан к материалу, поэтому заметку создать невозможно",
		"audioNeedsMaterial": "Этот пробел не связан с материалом, поэтому воспроизведение аудио невозможно",
		"actionTypes": {
			"repeat-cards": "Карточки",
			"mini-quiz": "Мини-тест",
			"study-note": "Учебная заметка",
			"ai-explain": "Чат с тьютором",
			"study-plan-add": "План обучения",
			"mindmap": "Диаграмма",
			"infographic": "Инфографика",
			"summary": "Краткий обзор",
			"audio": "Аудио"
		}
	}
}
